// Keep in sync with backend/config/roles.js
export const ROLES = Object.freeze({
  SUPER_ADMIN: 'SuperAdmin',
  FINANCE: 'Finance',
  BRAND_MANAGER: 'BrandManager',
  COMMISSARY_SUPERVISOR: 'CommissarySupervisor',
  OUTLET_MANAGER: 'OutletManager',
  PROCUREMENT_STAFF: 'ProcurementStaff',
});

export const ALL_ROLES = Object.values(ROLES);
